export const NAME = 'publicMessaging'
